import { render, staticRenderFns } from "./StaticPageLayoutPreview.vue?vue&type=template&id=c8400e0c&scoped=true&"
import script from "./StaticPageLayoutPreview.vue?vue&type=script&lang=js&"
export * from "./StaticPageLayoutPreview.vue?vue&type=script&lang=js&"
import style0 from "./StaticPageLayoutPreview.vue?vue&type=style&index=0&id=c8400e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8400e0c",
  null
  
)

export default component.exports